import {listGender, listTT_Don_Kinh} from "data/list";
import {formatDateToString, formatToCurrencyTypeFloor} from "helper/common";
import React from "react";
import {FIELD_TYPE, FORMAT_TIME, TT_DON_KINH} from "types/enums";
import {ColumnProps} from "types/models";
import StatusCard from "../StatusCard/StatusCard";
const {INPUT, DATE, COMBO_BOX} = FIELD_TYPE;

const fields = [
  {
    type: INPUT,
    name: "maPK",
    label: "Mã phiếu khám",
  },
  {
    type: INPUT,
    name: "maBenhNhan",
    label: "Mã bệnh nhân",
  },
  {
    type: INPUT,
    name: "id",
    label: "Mã đơn bán",
  },
  {
    type: INPUT,
    name: "hoTen",
    label: "Họ tên",
  },
  {
    type: DATE,
    name: "ngaySinh",
    label: "Ngày sinh",
  },
  {
    type: DATE,
    name: "start",
    label: "Ngày tạo từ",
  },
  {
    type: DATE,
    name: "end",
    label: "Ngày tạo đến",
  },
  {
    type: COMBO_BOX,
    name: "dateOfBirth",
    options: listGender,
    label: "Giới tính",
    expand: true,
  },
  {
    type: INPUT,
    name: "dienThoai",
    label: "Số điện thoại",
    expand: true,
  },

  {
    type: COMBO_BOX,
    name: "status",
    label: "Trạng thái đơn bán kính",
    options: listTT_Don_Kinh,
    expand: true,
  },
];

const columnsTable: ColumnProps[] = [
  {
    title: "STT",
    dataIndex: "stt",
    show: true,
    align: "center",
    width: 60,
    isResizable: true,
  },
  {
    title: "Mã BN",
    dataIndex: "maBenhNhan",
    show: true,
    width: 60,
    isResizable: true,
  },

  {
    title: "Mã PK",
    dataIndex: "idPhieuKham",
    show: true,
    width: 60,
    isResizable: true,
  },

  {title: "Mã đơn", dataIndex: "id", show: true, width: 60, isResizable: true},

  {
    title: "Tên BN/KH",
    dataIndex: "hoTen",
    show: true,
    width: 140,
    isResizable: true,
  },

  {
    title: "Giới tính",
    dataIndex: "gioiTinh",
    show: true,
    isResizable: true,
    render(value, record, index) {
      return <>{value == 0 ? "Nam" : value == 1 ? "Nữ" : ""}</>;
    },
    width: 60,
  },
  {
    title: "Ngày sinh",
    dataIndex: "ngaySinh",
    show: true,
    isResizable: true,
    render(value, record, index) {
      return <>{formatDateToString(value, FORMAT_TIME.dayFull)}</>;
    },
    width: 80,
  },
  {
    title: "Thời gian tạo",
    dataIndex: "createDate",
    show: true,
    isResizable: true,
    render(value, record, index) {
      return <>{formatDateToString(value, FORMAT_TIME.dateTime)}</>;
    },
    width: 120,
  },
  {
    title: "Thời gian bán",
    dataIndex: "thoiGianBan",
    show: true,
    isResizable: true,
    render(value, record, index) {
      return <>{formatDateToString(value, FORMAT_TIME.dateTime)}</>;
    },
    width: 120,
  },
  {
    title: "Trạng thái khám",
    dataIndex: "trangThaiKCB",
    show: true,
    isResizable: true,

    width: 120,
  },
  {
    title: "Trạng thái đơn",
    dataIndex: "status",
    show: true,
    isResizable: true,
    render(value, record, index) {
      return <StatusCard status={value}></StatusCard>;
    },
    width: 120,
  },
  {
    title: "Tổng GT đơn",
    dataIndex: "tongTien",
    show: true,
    isResizable: true,
    align: "right",
    render(value, record, index) {
      return <>{formatToCurrencyTypeFloor(value)}</>;
    },
    width: 90,
  },
  {
    title: "Hình thức thanh toán",
    dataIndex: "paymentsName",
    show: true,
    isResizable: true,
    align: "left",
    width: 120,
  },
  {
    title: "Kho bán",
    dataIndex: "storeId",
    show: true,
    width: 140,
    isResizable: true,
  },

  {
    title: "Phòng",
    dataIndex: "phong",
    show: true,
    width: 140,
    isResizable: true,
  },

  {
    title: "Bác sĩ",
    dataIndex: "tenBacSy",
    show: true,
    width: 140,
    isResizable: true,
  },

  {
    title: "Ghi chú",
    dataIndex: "ghiChu",
    show: true,
    width: 120,
    isResizable: true,
  },
];

export {fields, columnsTable};
